import { MouseEventHandler } from 'react'

import Button from '@/components/view/atoms/button/Button'
import SearchNotFoundImage, {
  NotFoundType
} from '@/components/view/atoms/image/SearchNotFoundImage'
import Text from '@/components/view/atoms/text/Text'
import GuidanceAreaContent from '@/components/view/layouts/area/GuidanceAreaContent'
import TextAlign from '@/components/view/layouts/text/TextAlign'

interface Props {
  searched?: boolean
  name?: string
  link?: string
  onClickReset?: MouseEventHandler
  mini?: boolean
  type?: NotFoundType
}

const NoResultGuidanceCore = ({ searched, name, link, onClickReset, mini, type }: Props) => {
  return (
    <>
      <SearchNotFoundImage size={mini ? 80 : 160} type={type} searched={searched} />
      <TextAlign>
        <Text size={14} weight='bold' align='center' tag='p'>
          {searched
            ? '条件にヒットするデータがありませんでした'
            : name
              ? `${name}がありません。${name}を追加しましょう`
              : 'データがありません'}
        </Text>
        {searched && (
          <Text align='center' tag='p'>
            検索条件を変更し再度お試しください。
          </Text>
        )}
      </TextAlign>
      {searched ? (
        <>
          {onClickReset && (
            <Button size='large' color='secondary' onClick={onClickReset}>
              条件をリセット
            </Button>
          )}
        </>
      ) : (
        name &&
        link && (
          <Button size='large' link={link}>
            {name}を追加する
          </Button>
        )
      )}
    </>
  )
}

const NoResultGuidance = (props: Props) => {
  return props.mini ? (
    <div className='w-full content-center items-center gap-2 px-4 pt-8 pb-4'>
      <NoResultGuidanceCore {...props} />
    </div>
  ) : (
    <GuidanceAreaContent>
      <NoResultGuidanceCore {...props} />
    </GuidanceAreaContent>
  )
}

export default NoResultGuidance
